<div class="min-h-screen bg-[#F3F4F6] dark:bg-slate-900 text-sm p-4 md:p-8 text-slate-600 dark:text-slate-300">
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">ตั้งค่า Quota Card</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        กำหนดโหมดกระจายโควต้าและนโยบายการจัดสรรบัตรต่อลาน
      </p>
    </div>
    <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
      <button (click)="onRefresh()" [disabled]="isLoading() || isSaving()"
        class="p-3 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 dark:hover:text-amber-400 hover:shadow-md transition-all active:scale-95 flex items-center justify-center h-[46px] disabled:opacity-50"
        title="รีเฟรชข้อมูล">
        <span class="material-icons">refresh</span>
      </button>
      <button *ngIf="canCreate || canUpdate" (click)="onSave()" [disabled]="!canSave || isSaving() || isLoading()"
        class="px-6 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl shadow-lg shadow-amber-200/50 dark:shadow-none flex items-center justify-center gap-2 h-[46px] transition-all disabled:opacity-50">
        <span class="material-icons text-xl">save</span>
        {{ isSaving() ? 'กำลังบันทึก...' : 'บันทึก' }}
      </button>
    </div>
  </div>

  <div *ngIf="!formModel"
    class="animate-fade-in bg-white dark:bg-slate-800 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 overflow-hidden"
    style="animation-delay: 0.1s;">
    <div class="py-24 text-center">
      <div class="flex flex-col items-center justify-center text-slate-400">
        <span class="material-icons text-5xl mb-3">location_city</span>
        <p class="font-bold text-slate-700 dark:text-slate-200 text-lg">กรุณาเลือกลาน (Site) จากแถบด้านข้าง</p>
        <span class="text-sm mt-1">เลือกลานก่อนตั้งค่าโควต้าบัตร</span>
      </div>
    </div>
  </div>

  <div *ngIf="formModel as cfg"
    class="animate-fade-in bg-white dark:bg-slate-800 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 overflow-hidden relative"
    style="animation-delay: 0.1s;"
    [class.opacity-60]="isLoading()">

    <div class="p-6 border-b border-slate-100 dark:border-slate-700 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
      <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">tune</span>
        การตั้งค่าโควต้า
        <span *ngIf="siteState.selectedSite()?.name"
          class="text-xs font-semibold text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/30 px-2 py-1 rounded-lg">
          {{ siteState.selectedSite()?.name }}
        </span>
      </h3>
      <span *ngIf="isEditMode"
        class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-bold bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400 border border-emerald-200 dark:border-emerald-800">
        <span class="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>
        มีการตั้งค่าแล้ว
      </span>
      <span *ngIf="isFirstSetup()"
        class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-bold bg-amber-50 dark:bg-amber-900/30 text-amber-700 dark:text-amber-400 border border-amber-200 dark:border-amber-800">
        <span class="material-icons text-sm">new_releases</span>
        ตั้งค่าครั้งแรก
      </span>
    </div>

    <div class="p-6 md:p-8 space-y-8">
      <div *ngIf="isFirstSetup()"
        class="flex items-start gap-3 p-4 rounded-2xl bg-amber-50/80 dark:bg-amber-900/20 border border-amber-200/70 dark:border-amber-500/30">
        <span class="material-icons text-amber-500 mt-0.5">info</span>
        <p class="text-sm text-amber-800 dark:text-amber-200 font-medium">
          ยังไม่เคยตั้งค่าโควต้าสำหรับลานนี้ — กำหนดค่าด้านล่างแล้วกด <strong>บันทึก</strong> เพื่อสร้างการตั้งค่าครั้งแรก
        </p>
      </div>

      <div class="p-4 rounded-2xl bg-amber-50/50 dark:bg-amber-900/10 border border-amber-200/60 dark:border-amber-500/30">
        <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">ลาน (Site)</label>
        <div class="text-sm font-bold text-slate-800 dark:text-slate-100">
          {{ siteState.selectedSite()?.name || ('Site ID ' + selectedSiteId) }}
        </div>
        <p class="text-xs text-slate-500 dark:text-slate-400 mt-1">อิงจากลานที่เลือกใน Sidebar</p>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div class="md:col-span-2">
          <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">
            โหมดกระจายโควต้า <span class="text-rose-500">*</span>
          </label>
          <div class="relative flex items-center bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
            <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">hub</span>
            <select [(ngModel)]="cfg.distributionMode"
              [disabled]="!canEditForm || isSaving() || isLoading()"
              class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium focus:outline-none disabled:opacity-50">
              <option *ngFor="let mode of distributionModes" [value]="mode.value">{{ mode.label }}</option>
            </select>
          </div>
          <p class="mt-2 text-xs text-slate-500 dark:text-slate-400 font-medium">
            <strong class="text-slate-700 dark:text-slate-300">Direct</strong> = HQ/ลานแจกโควต้าตรง
            &nbsp;|&nbsp;
            <strong class="text-slate-700 dark:text-slate-300">Via Distributor</strong> = ผ่านฝ่ายอาคารแจกให้ร้านค้า
          </p>
        </div>

        <div *ngIf="cfg.distributionMode === 'via_distributor'" class="md:col-span-2 animate-fade-in">
          <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">
            Client ฝ่ายอาคาร (Distributor) <span class="text-rose-500">*</span>
          </label>
          <div class="relative flex items-center bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
            <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">business</span>
            <select [(ngModel)]="cfg.distributorClientId"
              [disabled]="!canEditForm || isSaving() || isLoading()"
              class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium focus:outline-none disabled:opacity-50">
              <option [ngValue]="null">-- เลือก Client ฝ่ายอาคาร --</option>
              <option *ngFor="let client of clients()" [ngValue]="client.id">{{ client.name }}</option>
            </select>
          </div>
        </div>
      </div>

      <div>
        <h4 class="text-sm font-bold text-slate-800 dark:text-slate-100 mb-4 flex items-center gap-2">
          <span class="material-icons text-amber-500 text-lg">policy</span>
          นโยบายการจัดสรร
        </h4>
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <label
            class="flex items-start gap-3 p-4 rounded-2xl border border-slate-200 dark:border-slate-700 bg-slate-50/60 dark:bg-slate-900/40 cursor-pointer hover:border-amber-300 dark:hover:border-amber-600/50 transition-colors select-none"
            [class.opacity-50]="!canEditForm || isSaving() || isLoading()"
            [class.pointer-events-none]="!canEditForm || isSaving() || isLoading()">
            <input type="checkbox" class="mt-0.5 w-5 h-5 rounded border-slate-300 text-amber-500 focus:ring-amber-200"
              [(ngModel)]="cfg.allocationRequiresApproval" [disabled]="!canEditForm || isSaving() || isLoading()">
            <span class="text-sm">
              <span class="font-bold text-slate-800 dark:text-slate-100 block">การจัดสรรต้องอนุมัติ</span>
              <span class="text-xs text-slate-500 dark:text-slate-400 mt-0.5 block">ต้องผ่านขั้นตอนอนุมัติก่อนแจกโควต้า</span>
            </span>
          </label>

          <label
            class="flex items-start gap-3 p-4 rounded-2xl border border-slate-200 dark:border-slate-700 bg-slate-50/60 dark:bg-slate-900/40 cursor-pointer hover:border-amber-300 dark:hover:border-amber-600/50 transition-colors select-none"
            [class.opacity-50]="!canEditForm || isSaving() || isLoading()"
            [class.pointer-events-none]="!canEditForm || isSaving() || isLoading()">
            <input type="checkbox" class="mt-0.5 w-5 h-5 rounded border-slate-300 text-amber-500 focus:ring-amber-200"
              [(ngModel)]="cfg.tenantCanSelfManage" [disabled]="!canEditForm || isSaving() || isLoading()">
            <span class="text-sm">
              <span class="font-bold text-slate-800 dark:text-slate-100 block">ร้านค้าจัดการบัตรเองได้</span>
              <span class="text-xs text-slate-500 dark:text-slate-400 mt-0.5 block">ให้ tenant ออก/จัดการบัตรได้เอง</span>
            </span>
          </label>

          <label
            class="flex items-start gap-3 p-4 rounded-2xl border border-slate-200 dark:border-slate-700 bg-slate-50/60 dark:bg-slate-900/40 cursor-pointer hover:border-amber-300 dark:hover:border-amber-600/50 transition-colors select-none sm:col-span-2 lg:col-span-1"
            [class.opacity-50]="!canEditForm || isSaving() || isLoading()"
            [class.pointer-events-none]="!canEditForm || isSaving() || isLoading()">
            <input type="checkbox" class="mt-0.5 w-5 h-5 rounded border-slate-300 text-amber-500 focus:ring-amber-200"
              [(ngModel)]="cfg.returnQuotaOnNaturalExpiry" [disabled]="!canEditForm || isSaving() || isLoading()">
            <span class="text-sm">
              <span class="font-bold text-slate-800 dark:text-slate-100 block">คืนโควต้าเมื่อหมดอายุตามธรรมชาติ</span>
              <span class="text-xs text-slate-500 dark:text-slate-400 mt-0.5 block">คืน quota กลับเมื่อบัตรหมดอายุตามวันที่กำหนด</span>
            </span>
          </label>
        </div>
      </div>
    </div>

    <div *ngIf="canCreate || canUpdate"
      class="px-6 md:px-8 py-5 border-t border-slate-100 dark:border-slate-700 flex flex-col sm:flex-row justify-end gap-3 bg-slate-50/50 dark:bg-slate-900/30">
      <button type="button" (click)="onRefresh()" [disabled]="isLoading() || isSaving()"
        class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 font-bold text-slate-600 dark:text-slate-300 hover:bg-white dark:hover:bg-slate-800 transition-colors disabled:opacity-50">
        รีเซ็ต / โหลดใหม่
      </button>
      <button type="button" (click)="onSave()" [disabled]="!canSave || isSaving() || isLoading()"
        class="px-6 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold shadow-lg shadow-amber-200/50 dark:shadow-amber-900/30 transition-all disabled:opacity-50">
        {{ isSaving() ? 'กำลังบันทึก...' : 'บันทึกการตั้งค่า' }}
      </button>
    </div>
  </div>
</div>

<app-pss-loading *ngIf="isLoading()"></app-pss-loading>
